@import "~@uipath/apollo-core/src/scss/base-host.scss";
@import url("https://fonts.googleapis.com/icon?family=Material+Icons|Material+Icons+Outlined");

.pt-sheet {
    background-color: var(--color-background);
}
